import { shortenString } from "@lib/helpers/StringHelper";
import { Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import CoinPriceTextFormat from "@lib/components/MiniComponents/Others/CoinPriceTextFormat";
import { ColumnConfig, generateColumns } from "@lib/helpers/TableHelper";
import { TableColumnsProps } from "@lib/types/General";
import { XAICallLog } from "@lib/types/xAI";
import CallLength from "@lib/components/MiniComponents/Others/CallLength";
import {
  XAICallStatusTag,
  AppointmentTime,
} from "@lib/components/MiniComponents/Others";

type Props<T> = TableColumnsProps<T>;

const getColumns = <T extends XAICallLog>(props: Props<T>): ColumnsType<T> => {
  const columnsConfig: ColumnConfig<T>[] = [
    {
      title: "common.createdAt",
      dataIndex: "createdAt",
      width: "150px",
      render: (d) => dayjs(d).format("DD/MM/YYYY HH:mm:ss"),
    },

    {
      title: "common.agent",
      dataIndex: "rawCallback.agentName",
      width: "150px",
      filterType: "search",
      render: (d, r) => shortenString(r?.rawCallback?.agentName, 20),
    },

    {
      title: "common.duration",
      dataIndex: "rawCallback.durationMs",
      width: "150px",
      filterType: "search",
      render: (_, r) => (
        <CallLength callLength={Number(r?.rawCallback?.durationMs || 0)} />
      ),
    },

    {
      title: "common.callCost",
      dataIndex: "rawCallback.callCost",
      width: "150px",
      filterType: "search",
      render: (_, r) => (
        <CoinPriceTextFormat
          amount={Number(r?.rawCallback?.callCost || 0)}
          showCurrencySymbol
        />
      ),
    },
    {
      title: "common.callStatus",
      dataIndex: "rawCallback.callStatus",
      width: "150px",
      filterType: "dropdown",
      render: (_, r) =>
        r?.rawCallback?.callStatus ? (
          <XAICallStatusTag status={r.rawCallback.callStatus} size="small" />
        ) : (
          " - "
        ),
    },

    {
      title: "common.nextStep",
      dataIndex: "rawCallback.nextStep",
      width: "150px",
      filterType: "dropdown",
    },

    {
      title: "common.summary",
      dataIndex: "rawCallback.summary",
      width: "150px",
      filterType: "dropdown",
    },

    {
      title: "common.callbackError",
      dataIndex: "callbackError",
      width: "150px",
      filterType: "search",
      render: (d) => <Tooltip title={d}>{shortenString(d, 20)}</Tooltip>,
    },

    {
      title: "common.appointmentTime",
      dataIndex: "appointmentTime",
      width: "180px",
      filterType: "search",
      render: (_, r) => (
        <AppointmentTime appointmentTime={r?.appointmentTime} size="small" />
      ),
    },

    // {
    //   title: "#",
    //   dataIndex: "actions",
    //   className: "order-table-action",
    //   fixed: "right",
    //   width: "150px",
    //   render: (_, record) => (
    //     <StyledFlex className="actions">
    //       <ActionButton
    //         type="blockChain"
    //         href={record?.extraData?.transactionDetailUrl || null}
    //         targetBlank
    //         disabled={!record?.extraData?.transactionDetailUrl}
    //       />
    //     </StyledFlex>
    //   ),
    // },
  ];

  return generateColumns(props, columnsConfig);
};
export default getColumns;
